"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _toolTip = _interopRequireDefault(require("../../toolTip"));
var _tab = _interopRequireWildcard(require("../../tabs/tab"));
var _colourModule = _interopRequireDefault(require("./colour.module.scss"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ColourSwatch = function ColourSwatch(props) {
  var swatch = /*#__PURE__*/_react["default"].createRef();
  var getClass = function getClass(props) {
    return "".concat(_colourModule["default"].swatch, " ").concat(props.active ? _colourModule["default"].active : "");
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: getClass(props),
    "data-testid": "colour-swatch",
    ref: swatch
  }, /*#__PURE__*/_react["default"].createElement("div", {
    key: props.colour,
    "data-testid": "colour-swatch-container",
    className: _colourModule["default"].container,
    onClick: function onClick() {
      if (!props.active && props.onClick) {
        props.onClick();
      }
    },
    style: _objectSpread({}, props.style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "colour-swatch-colour",
    className: _colourModule["default"].swatch,
    style: {
      background: props.colour
    }
  }))), props.label && /*#__PURE__*/_react["default"].createElement(_toolTip["default"], {
    position: "Top",
    target: swatch
  }, [/*#__PURE__*/_react["default"].createElement(_tab["default"], {
    key: props.label
  }, /*#__PURE__*/_react["default"].createElement(_tab.Content, null, props.label))]));
};
ColourSwatch.propTypes = {
  colour: _propTypes["default"].string,
  label: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
ColourSwatch.defaultProps = {
  colour: "#000000",
  active: false
};
var _default = exports["default"] = ColourSwatch;